module.exports = __webpack_public_path__ + "img/Flag_of_Croatia.3e56776d.svg";